import { useIntersectionObserver } from "hooks/useIntersectionObserver";
import { InfiniteScrollContainerProps } from "./types";
import { Loader2 } from "lucide-react";

export const InfiniteScrollContainer = ({
  children,
  isActive = true,
  isLoading = false,
  triggerOnce = false,
  rootMargin = "0px",
  loadingElement,
  onEndReached,
}: InfiniteScrollContainerProps) => {
  const { observerTarget } = useIntersectionObserver({
    callback: onEndReached,
    rootMargin,
    triggerOnce,
  });

  return (
    <>
      {children}
      {isActive && <div ref={observerTarget} className="h-px w-full" />}
      {isLoading && (
        <div className="p-4 text-center">
          {loadingElement || (
            <Loader2 className="mx-auto h-8 w-8 animate-spin text-gray-500" />
          )}
        </div>
      )}
    </>
  );
};
